import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Box, Flex, Icon, Image, Text } from '@chakra-ui/react';
import { Divider, Tabs } from 'components';
import { Accordion } from 'components/Accordion';
import { Button } from 'components/Button';
import { Visible } from 'components/Visible';
import { TbLuggage } from 'react-icons/tb';
import { useHistory } from 'react-router-dom';
import { timeDiffCalc, routes, DAYS, MONTHS } from 'utils';

type Baggage = {
    type: string;
    size: number;
    pieces: number;
}

type Cancellation = {
    time: string;
    charge: string;
}

type Way = {
    startDateTime: Date;
    endDateTime: Date;
    companyName: string;
    logo: string;
    type: string;
    departureName: string;
    arrivalName: string;
    tripNumber:string;
    classType: string;
    baggage: Baggage;
    cancellation: Cancellation;
}

type Trip = {
    ways: Way[];
    limitedSeats?: number;
    price: number
};

type TripTileProps = {
  data: Trip;
  isFlight?: boolean;
};

const TripTile = ({ data, isFlight }: TripTileProps) => {
    const history = useHistory();
    const onBooking = () => history.push(routes.BOOKING.HOW_TO_PAY);

    const tabList = [{
        id: 1,
        title: 'Itinerary',
        content:<Flex justifyContent='flex-start' marginBottom='16px'>
        <Flex justifyContent='space-between' width="250px" flexDirection='column' alignItems='center' paddingTop='24px'paddingRight='24px' >
                <Image src={data.ways[0].logo} paddingBottom='24px' />
                <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>{data.ways[0].companyName}</Text>
        </Flex>
        <Flex justifyContent='space-between' flexDirection='column' paddingTop='24px' width='450px'>
            {data.ways.map((way) => <>
            <Flex justifyContent='space-between' flexDirection='column' align='center' paddingTop='10px'>
                    <Text fontFamily='Montserrat' paddingRight='5px' fontSize='16px' fontWeight={500} color='#000000'>
                        {`${DAYS[way.startDateTime.getDay()]}, ${way.startDateTime.getDate()} ${MONTHS[way.startDateTime.getMonth()]} ${way.startDateTime.getFullYear()}`}
                    </Text>
                <Flex align='center' width='80%' justifyContent='space-between'>
                    <Text fontFamily='Montserrat' paddingRight='5px' fontSize='32px' fontWeight={500} color='#000000'>
                        {`${way.startDateTime.getHours()}:${way.startDateTime.getMinutes()}`}
                    </Text>
                    <Divider width='10%' />
                    <Text fontFamily='Montserrat' fontSize='12px' backgroundColor='#E9EEF1' padding='3px' borderRadius='20px' fontWeight={400} color='#1F1E1E'>
                        {`${timeDiffCalc(way.startDateTime, way.endDateTime).difference}`}
                    </Text>
                    <Divider width='10%' />
                    <Text paddingLeft='5px' fontFamily='Montserrat' fontSize='32px' fontWeight={500} color='#000000'>
                        {`${way.endDateTime.getHours()}:${way.endDateTime.getMinutes()}`}
                    </Text>
                </Flex>
                <Flex width='80%' flexDirection='column' align='flex-start' paddingTop='10px'>
                    <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#000000'>
                        {`${way.departureName} to ${way.arrivalName}`}
                    </Text>
                    <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#000000'>
                        {`Flight Number: ${way.tripNumber}`}
                    </Text>
                    <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#000000'>
                        {`${way.classType} Class`}
                    </Text> 
                    <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#000000'>
                        {`${data.ways[0].baggage.size} kg(${data.ways[0].baggage.pieces}Pcs), ${data.ways[0].baggage.type} Luggage`}
                    </Text>
                </Flex>
            </Flex>
            </>
        )}
        </Flex>
    </Flex>
    },
    {
        id: 2,
        title: 'Baggage',
        content:<Flex justifyContent='space-between' flexDirection='column' align='center' paddingTop='10px'>
            <Flex align='center' width='80%' justifyContent='space-between'>
                <Text fontFamily='Montserrat' fontSize='18px' fontWeight={700} color='#000000'>
                    Baggage
                </Text>
                <Text fontFamily='Montserrat' fontSize='18px' fontWeight={700} marginRight='9%' color='#000000'>
                    Size
                </Text>
            </Flex>
            <Flex  width='80%' justifyContent='space-between' align='center' paddingTop='20px'>
                <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#000000'>
                    {data.ways[0].baggage.type}
                </Text>
                <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#000000'>
                {`${data.ways[0].baggage.size} kg(${data.ways[0].baggage.pieces}Pcs)`}
                </Text>
            </Flex>
        </Flex>
    },
    {
        id: 2,
        title: 'Cancellation',
        content:<Flex justifyContent='space-between' flexDirection='column' align='center' paddingTop='10px'>
        <Flex align='center' width='80%' justifyContent='space-between'>
            <Text fontFamily='Montserrat' fontSize='18px' fontWeight={700} color='#000000'>
                Time
            </Text>
            <Text fontFamily='Montserrat' fontSize='18px' fontWeight={700} color='#000000'>
                Charge
            </Text>
        </Flex>
        <Flex  width='80%' justifyContent='space-between' align='center' paddingTop='20px'>
            <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#000000'>
                {data.ways[0].cancellation.time}
            </Text>
            <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#62AEEB'>
                {data.ways[0].cancellation.charge}
            </Text>
        </Flex>
    </Flex>
    }];

  return (
    <Box
      width='850px'
      paddingLeft='24px'
      height='fit-content'
      boxShadow='3px 20px 25px -5px rgba(151, 151, 151, 0.1), 3px 10px 10px -5px rgba(151, 151, 151, 0.04)'
      borderRadius='20px'
      backgroundColor='#F9F9F9'
    >
        <Flex justifyContent='flex-start' marginBottom='16px'>
            <Flex justifyContent='space-between' width="250px" flexDirection='column' alignItems='center' paddingTop='24px'paddingRight='24px' >
                    <Image src={data.ways[0].logo} paddingBottom='24px' />
                    <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>{data.ways[0].companyName}</Text>
            </Flex>
            <Flex justifyContent='space-between' flexDirection='column' paddingTop='24px' width='450px'>
                {data.ways.map((way) => <>
                <Flex justifyContent='space-between' flexDirection='column' align='center' paddingTop='10px'>
                    <Flex align='center' width='80%' justifyContent='space-between'>
                        <Text fontFamily='Montserrat' paddingRight='5px' fontSize='32px' fontWeight={500} color='#000000'>
                            {`${way.startDateTime.getHours()}:${way.startDateTime.getMinutes()}`}
                        </Text>
                        <Divider width='10%' />
                        <Text fontFamily='Montserrat' fontSize='12px' backgroundColor='#E9EEF1' padding='3px' borderRadius='20px' fontWeight={400} color='#1F1E1E'>
                            {`${timeDiffCalc(way.startDateTime, way.endDateTime).difference}`}
                        </Text>
                        <Divider width='10%' />
                        <Text paddingLeft='5px' fontFamily='Montserrat' fontSize='32px' fontWeight={500} color='#000000'>
                            {`${way.endDateTime.getHours()}:${way.endDateTime.getMinutes()}`}
                        </Text>
                    </Flex>
                    <Flex width='80%' justifyContent='space-between' align='center' paddingTop='10px'>
                        <Text fontFamily='Montserrat' fontSize='12px' fontWeight={500} color='#A3A3A3'>
                            {way.departureName}
                        </Text>
                        <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#3498FE'>
                            {way.type}
                        </Text>
                        <Text fontFamily='Montserrat' fontSize='12px' fontWeight={500} color='#A3A3A3'>
                            {way.arrivalName}
                        </Text>
                    </Flex>
                </Flex>
                <Flex align='center' justifyContent='flex-end' paddingTop='10px'>
                        <Visible when={!!data.ways[0].baggage}>
                                <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>
                                    Cost Includes
                                </Text>
                                <Icon as={TbLuggage} color='#A3A3A3' marginLeft='5px' marginRight='5px' />
                                <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>
                                    {`${data.ways[0].baggage.size} kg(${data.ways[0].baggage.pieces}Pcs)`}
                                </Text>
                        </Visible>
                    </Flex>
                </>
            )}
            </Flex>
            <Flex justifyContent='space-between' flexDirection='column' paddingTop='24px' align='center' paddingLeft='20px'>
                <Visible when={!!data.limitedSeats}>
                    <Text fontFamily='Montserrat' fontSize='12px' fontWeight={400} color='#F24866'>
                        {`${data.limitedSeats} Seats left`}
                    </Text>
                </Visible>
                <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>
                    Total Price
                </Text>
                <Text fontFamily='Montserrat' fontSize='26px' fontWeight={500} color='#1F1E1E'>
                    {`${data.price} EUR`}
                </Text>
                <Button label='Book' minWidth='120px' onClick={onBooking} colorScheme='blue' rightIcon={<ArrowForwardIcon />} />
            </Flex>
        </Flex>
        <Visible when={!!isFlight}>
            <Accordion labelColor='#3498FE'  label='Flight Details'>
                    <Tabs tabList={tabList} alignment="space-between" variant='line' unstyled  />
            </Accordion>
        </Visible>
    </Box>
  );
};

export { TripTile };
